import DeviceReregistrationSecondForm
    from "../../../forms/DeviceRegistrationForms/Reregistration/DeviceReregistrationSecondForm";
import "../DeviceBaseRegistration.css"

const DeviceReregistrationSecond = () => {
    return (
        <>
            <DeviceReregistrationSecondForm/>
        </>
    )
}

export default DeviceReregistrationSecond;
